export const DEFAULT_BILLING_PLANS = {
  'plan-1': {
    id: 'plan-1',
    label: 'Plano 1',
    rangeLabel: 'Até R$ 500.000/mês',
    revenueMin: 0,
    revenueMax: 500000,
    monthlyPrice: 1500,
    defaultMonthlyPrice: 1500,
    monthlyPriceLabel: 'R$ 1.500/mês'
  },
  'plan-2': {
    id: 'plan-2',
    label: 'Plano 2',
    rangeLabel: 'De R$ 500.001 até R$ 1.000.000/mês',
    revenueMin: 500001,
    revenueMax: 1000000,
    monthlyPrice: 3500,
    defaultMonthlyPrice: 3500,
    monthlyPriceLabel: 'R$ 3.500/mês'
  },
  'plan-3': {
    id: 'plan-3',
    label: 'Plano 3',
    rangeLabel: 'De R$ 1.000.001 até R$ 1.500.000/mês',
    revenueMin: 1000001,
    revenueMax: 1500000,
    monthlyPrice: 8000,
    defaultMonthlyPrice: 8000,
    monthlyPriceLabel: 'R$ 8.000/mês'
  },
  'plan-4': {
    id: 'plan-4',
    label: 'Plano 4',
    rangeLabel: 'Acima de R$ 1.500.000/mês',
    revenueMin: 1500001,
    revenueMax: Infinity,
    monthlyPrice: 15000,
    defaultMonthlyPrice: 15000,
    monthlyPriceLabel: 'Personalizado'
  }
};

export const getPlanForRevenue = (revenueValue, overrides = {}) => {
  const revenue = Number(revenueValue) || 0;

  const plan = Object.values(DEFAULT_BILLING_PLANS).find(item => {
    if (item.id === 'plan-4') {
      return revenue >= item.revenueMin;
    }
    return revenue >= item.revenueMin && revenue <= item.revenueMax;
  }) || DEFAULT_BILLING_PLANS['plan-1'];

  const planId = overrides.planId || plan.id;
  const planMeta = DEFAULT_BILLING_PLANS[planId] || plan;

  return {
    planId: planMeta.id,
    plan: planMeta,
    monthlyPrice: overrides.customMonthlyPrice ?? planMeta.monthlyPrice ?? planMeta.defaultMonthlyPrice,
    dueDay: overrides.dueDay ?? 10,
    recurringMonthly: overrides.recurringMonthly ?? true,
    revenue
  };
};

export const calculateLastSixMonthsRevenue = (reservations = [], now = new Date()) => {
  const safeNow = now instanceof Date ? now : new Date(now);
  const startDate = new Date(safeNow.getFullYear(), safeNow.getMonth() - 5, 1);

  return (reservations || [])
    .filter(item => {
      const createdAt = item?.createdAt?.toDate ? item.createdAt.toDate() : new Date(item?.createdAt || 0);
      if (Number.isNaN(createdAt.getTime())) {
        return false;
      }
      return createdAt >= startDate && createdAt <= safeNow && Number(item?.paidAmount || 0) > 0;
    })
    .reduce((sum, item) => sum + Number(item?.paidAmount || 0), 0);
};

export const resolveBillingSettings = ({ revenue, recurringMonthly = true, customMonthlyPrice = null, dueDay = 10 } = {}) => {
  const detected = getPlanForRevenue(revenue, {
    recurringMonthly,
    customMonthlyPrice,
    dueDay
  });

  return {
    ...detected,
    monthlyPrice: customMonthlyPrice ?? detected.plan.defaultMonthlyPrice,
    recurringMonthly,
    dueDay,
    revenue
  };
};

export const buildBillingAlertMessage = ({ plan, monthlyPrice, dueDay }) => {
  const label = plan?.label || 'Plano';
  return `Cobrança do ${label} em ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(monthlyPrice || 0)} no dia ${dueDay}.`;
};

export const getCurrentMonthKey = (date = new Date()) => {
  const safeDate = date instanceof Date ? date : new Date(date);
  return `${safeDate.getFullYear()}-${safeDate.getMonth() + 1}`;
};

export const calculateSystemNetReceipt = ({ monthRevenue = 0, monthlyPrice = 0, systemRevenuePercentage = 0, monthlyCostDeductionPercentage = 0 } = {}) => {
  const revenueShare = Number(monthRevenue || 0) * (Number(systemRevenuePercentage || 0) / 100);
  const monthlyCostDeduction = Number(monthlyPrice || 0) * (Number(monthlyCostDeductionPercentage || 0) / 100);

  return {
    revenueShare,
    monthlyCostDeduction,
    netReceipt: revenueShare - monthlyCostDeduction
  };
};
